enum WorkspaceSubscriptionPlan {
  Free = 'Free',
  Essentials = 'Essentials',
  Advanced = 'Advanced',
  Premium = 'Premium',
}

export default WorkspaceSubscriptionPlan
